import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { FormBaseComponent } from '../forms/form-base/form-base.component';
import { IFormConfig } from '../forms/form.types';

export interface IFormDialogComponentDialogData {
  formFields: FormlyFieldConfig[];
  title: string;
  cancelText?: string;
  confirmText?: string;
  hideSubmitButton?: boolean;
}

@Component({
  selector: 'app-form-dialog',
  templateUrl: './form-dialog.component.html',
  imports: [FormBaseComponent],
})
export class FormDialogComponent {
  formConfig: IFormConfig;

  constructor(
    public dialogRef: MatDialogRef<FormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IFormDialogComponentDialogData,
    private translateService: TranslateService
  ) {
    this.formConfig = {
      card: {
        header: {
          title: {
            label: '',
          },
        },
        footer: {
          button1: {
            label: this.data.confirmText ?? 'OK',
            disabled: false,
            hide: this.data.hideSubmitButton,
            type: 'submit',
            onClick: () => {},
          },
          button2: {
            label: this.data.cancelText ?? this.translateService.instant('common.cancel'),
            disabled: false,
            type: 'button',
            onClick: () => {
              this.closeDialog();
            },
          },
        },
      },
      formFields: this.data.formFields,
      formModel: {},
      options: {},
      title: this.data.title,
    };
  }

  onFormSubmitted(value) {
    this.dialogRef.close(value);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
